import Vue from "vue";
import VueRouter from "vue-router";
import formatrole from '@/helpers/formatroles.js'
import Storage from '@/helpers/storage.js'
import store from '../store'


Vue.use(VueRouter);


const routes = [
	{
		path: "/",
		name: "tribeId",
		component: () => import(/* webpackChunkName: "TribeId" */"@/views/TribeId.vue"),
	},
	{
		path:'/admin/login',
		name:'admin-login',
		component:() => import(/* webpackChunkName: "Login" */'@/admin/Login.vue')
	},
	{
		path:'/accounts/signup/',
		namne:'entity-signup',
		component:() => import(/* webpackChunkName: "signup" */'@/entity/SignUp.vue')
	},
	{
		path:'/accounts/signin/',
		name:'entity-login',
		component:()=> import(/* webpackChunkName: "signin" */'@/entity/SingIn.vue')
	},
	{
		path:'/entity/password/reset',
		name:'entity_reset_password',
		component:()=> import(/* webpackChunkName: "resetPaswsord" */'@/entity/ResetPassword.vue')
	},
	{
		path:'/admin/password/reset',
		name:'admin_reset_password',
		component:()=> import(/* webpackChunkName: "resetPaswsord" */'@/admin/ResetAdminPassword.vue')
	},
	{
		path:'/admin',
		name:'admin-dashboard',
		component:() => import(/* webpackChunkName: "admindashboard" */'@/admin/AdminDashBoard.vue'),
			children: [
				{
					path:'/super_admin',
					name:'super-admin',
					component: () => import(/* webpackChunkName: "superadmin" */'@/admin/supadmin/SuperAdmin.vue')
				},
				{
					path:'/global_admin',
					name:'global_admin',
					component: () => import(/* webpackChunkName: "globaladmin" */'@/admin/globaladmin/GlobalAdmin.vue')
				},
				{
					path:'/market_admin',
					name:'market_admin',
					component:()=> import(/* webpackChunkName: "marketadmin" */'@/admin/marketadmin/MarketAdminHome.vue')
				},
				{
					path:'/markets',
					name:'markets',
					component:() => import(/* webpackChunkName: "markets" */'@/admin/marketadmin/Markets.vue')
				},
				{
					path:'/super_admin_market',
					name:'super-admin-market',
					component:() => import('@/admin/supadmin/marketplace.vue')
				},
				{
					path:'/market_admin',
					name:'Marketplace',
					component:() => import('@/admin/marketadmin/marketplace.vue')
				},
				{
					path:'/gobal_admin_market',
					name:'global-admin',
					component:() => import('@/admin/globaladmin/marketplace.vue')
				},
				{
					path:'/entityadmin/manageentities',
					name:'entity_admin',
					component:()=> import(/* webpackChunkName: "entity_admin" */'../admin/entityadmin/EntityAdmin.vue')
				},
				{
					path:'/entityadmin/dashboard',
					name:'entityadmin-dashboard',
					component:()=> import(/* webpackChunkName: "final_afctnumber" */'../admin/entityadmin/AssignFinalAFCFTANumber.vue')
				},
				
				{
					path:'/settings',
					name:'settings',
					component:()=> import(/* webpackChunkName: "changepassword" */'../admin/ChangePassword.vue')
				},
				// superadmins, globaladmins and marketadmins give mandates
				{
					path:'/organisations/give_mandate',
					name:'admins_give_organisation_mandate',
					component:()=> import(/* webpackChunkName: "resetPaswsord" */'@/admin/mandates/Organisations.vue')

				},
				{
					path:'/agencies/give_mandate',
					name:'admins_give-agencies_mandate',
					component:()=> import(/* webpackChunkName: "resetPaswsord" */'@/admin/mandates/Agencies.vue')

				},
				{
					path:'/outlets/give_mandate',
					name:'admins_give_outlets_mandate',
					component:()=> import(/* webpackChunkName: "resetPaswsord" */'@/admin/mandates/Outlets.vue')

				},
				{
					path:'/admins/entities',
					name:'entities',
					component:()=> import(/* webpackChunkName: "resetPaswsord" */'@/admin/alldmins/Entities.vue')

				},
				{
					path:'/admins/users',
					name:'users',
					component:()=> import(/* webpackChunkName: "resetPaswsord" */'@/admin/alldmins/Users.vue')

				},
				{
					path:'/blog/debate-articles',
					name:'debate-articles',
					component:()=> import(/* webpackChunkName: "token" */'../admin/debate/debateHome.vue')
				},
				{
					path:'/blog/debate-articles/:id/contributions',
					name:'debate-contributions',
					component:()=> import(/* webpackChunkName: "token" */'../admin/debate/DebateContributions.vue')
				},
				{
					path:'/blog/challenge',
					name:'challenge',
					component:()=> import(/* webpackChunkName: "token" */'../admin/challenge/ChallengeHome.vue')
				},
				{
					path:'/blog/challenge/:challengeID/contributions',
					name:'challenge-contributions',
					component:()=> import(/* webpackChunkName: "token" */'../admin/challenge/challengeContiributions.vue')
				},
				{
					path:'/blog/articles',
					name:'challenge-articles',
					component:()=> import(/* webpackChunkName: "token" */'../admin/articles/articlesHome.vue')
				},
				
			]
	},
	// Entity dashboard routes goes here
	{
		path:'/user',
		name:'user',
		redirect:{name:'dashboard'},
		component:()=> import(/* webpackChunkName: "entity" */'../entity/Layout.vue'),
			children : [
				{
					path:'/user/dashboard',
					name:'dashboard',
					component: ()=> import( '../entity/Dashboard.vue')
				},
				{
					path:'/manage_tokens',
					name:'tokens',
					component:()=> import(/* webpackChunkName: "token" */'../entity/Token.vue')
				},
				{
					path:'/search-afcfta-number',
					name:'search-afcfta-number',
					component:()=> import(/* webpackChunkName: "token" */'../entity/ProductRegisteration.vue')
				},
				{
					path:'/api-product-registeration',
					name:'api-product-registeration',
					component:()=> import(/* webpackChunkName: "token" */'../entity/ApiProductRegisteration.vue')
				},
				{
					path:'/entity_user/:id/update_product_registeration',
					name:'submission-form',
					props:true,
					component:()=> import(/* webpackChunkName: "token" */'../entity/SubmissionForm.vue')
				},
				{
					path:'/my_collections',
					name:'my-collection',
					props:true,
					component:()=> import(/* webpackChunkName: "token" */'../entity/MyCollections.vue')
				},
				{
					path:'/user/data_providers',
					name:'user-data-providers',
					component:()=> import(/* webpackChunkName: "token" */'../entity/DataProviders.vue')
				},
				{
					path:'/user/my_dataproviders',
					name:'user-my-dataproviders',
					component:()=> import(/* webpackChunkName: "token" */'../entity/MyDataProviders.vue')
				},
				{
					path:'/user/request_entity',
					name:'user-request-entity',
					component:()=> import(/* webpackChunkName: "token" */'../entity/RequestEntity.vue')
				},

				//  ENTITY MANAGEMENT
				 {
					path:'/user/entity/:id',
					name:'user-entity_management',
					redirect:'/user/entity/:id/add_users',
					props:true,
					component:()=> import(/* webpackChunkName: "token" */'../entity/EntityManagement/EntityManagementHome.vue'),
						children: [
							{
								path:'/user/entity/:id/add_users',
								name:'user-entity_addusers',
								props:true,
								component:()=> import(/* webpackChunkName: "token" */'../entity/EntityManagement/UsersManagement.vue'),
							},
							{
								path:'/user/entity/:id/dataproviders',
								name:'user-entity_dataproviders',
								props:true,
								component:()=> import(/* webpackChunkName: "token" */'../entity/EntityManagement/DataprovidersManageMent.vue'),
							},
							{
								path:'/user/entity/:id/entity_dataproviders',
								name:'user-entities_dataproviders',
								props:true,
								component:()=> import(/* webpackChunkName: "token" */'../entity/EntityManagement/EntityDataProviders.vue'),
							},
							{
								path:'/user/entity/:id/users',
								name:'user-enitity_users',
								props:true,
								component:()=> import(/* webpackChunkName: "token" */'../entity/EntityManagement/Users.vue'),
							},
							{
								path:'/user/entity/:id/payment_and_transaction',
								name:'user-enitity_paymentAndTransactions',
								props:true,
								component:()=> import(/* webpackChunkName: "token" */'../entity/TokenManagement/TokenHome.vue'),
							},
							{
								path:'/user/entity/:id/calls',
								name:'user-enitity_calls',
								props:true,
								component:()=> import(/* webpackChunkName: "token" */'../entity/callManagement/Home.vue'),
							},
							{
								path:'/user/entity/:id/issue_call',
								name:'user-enitity_issue_call',
								props:true,
								component:()=> import(/* webpackChunkName: "token" */'../entity/callManagement/IssueCall.vue'),
							},

						]
				 }
			]
	},
	{
		path:'*',
		component:()=> import(/* webpackChunkName: "404" */'@/components/404.vue')
	}
];


const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,	
});

// redirectin and access control 

const admin = Storage.get('dashboard')
if( admin ) {
	router.beforeEach( (to,from,next)=> {
		if(to.path === '/admin') {
			next(`${admin.links.sidebar[0].route}`)
		}
			next()	
	})
}
// redirecting to entity dashboard
// router.beforeEach( (to, from, next) => {
// 	if(to.path === '/entity') {
// 		next('/entity/dashboard')
// 	}
// 	next()
// })
router.beforeEach((to, from, next) => {
	const ticket = to.query.ticket
	if(to.path === "/" && ticket) {
		store.dispatch('validateServiceTicket',ticket)
			.then(response => next('/user/dashboard') )

	}
	next()
  })
export default router;
